export enum Pages {
  LOADING = 'loading',
  START = 'start',
  ONBOARDING = 'onboarding',
  GAME = 'game',
  FINAL = 'final',
}

export interface stateType {
  currentPage: Pages;
  onboardingPage: number;
  endGame: boolean;
}
